<template>
	
	<Modal :value="value" title="清空指定年份数据" @on-cancel = "cancel">
		<Form ref="deleteForm"  :label-width="80" :rules="rule" :model="salary">
			<FormItem label='年份'  prop="year">
				<DatePicker
				  type="year"
				  @on-change="salary.year=$event"
				  v-model="salary.year"
				  placeholder="请选择"
				  :editable="false"
				  style="width:180px; padding-right:20px;"
				></DatePicker>
			</FormItem>
		</Form>
		
		<!-- <FormItem label="年份" prop="year">
		  <Row :gutter="20">
		    <Col span="20">
		    <DatePicker type="year" placeholder="请选择 " style="width: 100%" :editable="false" @on-change="salary.year = $event" :value="salary.year" />
		    </Col>
		  </Row>
		</FormItem> -->
		<div slot="footer">
			<!-- <Button type="primary" @click="test" :loading='BtnDisabled'>检测</Button>&nbsp; -->
			<Button type="primary" @click="deleteImport" >清空</Button>&nbsp;
		</div>
	</Modal>
	
</template>

<script>
	export default {
		props:{
			value:false,
		},
		data () {
			return {
				BtnDisabledOK:true,
				BtnDisabled:false,
				action:abp.url+'/file/Upload',
				salary:{
					year:null
				},
				rule:{
					year: [
					  {
					    required: true,
					    pattern: /.+/,
					    message: '年份不能为空',
					    trigger: 'blur',
					  },
					],
				},
			}
		},
		mounted() {
			
		},
		methods:{
			
			//假期分配
			deleteImport(){
				this.$refs.deleteForm.validate(async(valid)=>{
				    if(valid){
            let reponse = await this.$Ajax.get('api/services/app/PostWorkdaySetting/DeleteImport',{params:this.salary});
						if(reponse.data.result){
							this.$Message.success("清空成功");
						    this.$emit('close')
						}else{
              this.$Modal.confirm({
                title: "提示",
                content: reponse.data.result.errorMsg,
                okText: "确认",
                // onOk: () => {
                // },
              });
            }
				    }
				})
			},
			cancel(){
				this.$emit('close')
			},
		}
	}
</script>

<style>
</style>
